import { render } from "./p-secure.vue?vue&type=template&id=057b5984"
import script from "./p-secure.vue?vue&type=script&lang=js"
export * from "./p-secure.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/p-secure.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "057b5984"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('057b5984', __exports__)) {
    api.reload('057b5984', __exports__)
  }
  
  module.hot.accept("./p-secure.vue?vue&type=template&id=057b5984", () => {
    api.rerender('057b5984', render)
  })

}


export default __exports__